import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import {
  getBacksplashTotalArea, getCabinetsDoorsSQFT, getCabinetsLNFT, getCabinetsVolume,
  getCountertopArea, getEdgesArea, getQuantityFromFilters,
  manualCalculationsBacksplashArea,
  manualCalculationsCountertopArea,
  manualCalculationsEdgesLength,
} from "../helpers/sqftCalculations";
import SqftFooterAddToQuoteButton from "./SqftFooterAddToQuoteButton";
import SqftFooterCancelButton from "./SqftFooterCancelButton";
import SqftFooterActiveShapeColorset from "./sqftFooterActiveShapeColorset";
import SqftFooterSlabInfo from "./sqftFooterSlabInfo";
import sqftConfig from "./canvas/store/sqftConfig";
import {CABINET_BOXES, MEASURE_UNITS, SHAPE_PART_ID, SIDEBAR_BUTTONS_MENU} from "../constants";
import { setSQFTActiveButton, setSQFTMenuOpened } from "../../../actions/sqftMenuFunctions";
import sqftSlabManager from "./canvas/store/sqftSlabManager";
import Config from "../../../config";

const MEASURE_UNITS_LABELS = {
  [MEASURE_UNITS.Metric]: { area: 'm²', length: 'm', volume: 'm³', empty: '' },
  [MEASURE_UNITS.Imperial]: { area: '\'', length: '"', volume: '\'', empty: '' },
};

const InfoPanel = ({ titleId, value, unit, value2, unit2 }) => (
  value > 0 && (
    <div className="info-panel-wrapper">
      <span className="info-panel-title">
        <FormattedMessage id={titleId} />:
      </span>
      <span className="info-panel-container">
        <span>{value}{unit}</span>
        {value2 ? <span> / {value2}{unit2}</span> : null}
      </span>
    </div>
  )
);

const SqftFooter = ({
                      updateCalculations, showManualCalculation, croppedSlabImages, fabricatorData,
                      isMobile, isShowSlabTool, menuOpened, countertopRows, backsplashRows, edgeRows,
                      setSQFTActiveButton, setSQFTMenuOpened, isModalFixOpen
                    }) => {
  const [totals, setTotals] = useState({
    countertopArea: 0,
    edgesArea: 0,
    backsplashArea: 0,
    slabs: 0,

    baseSQFT: 0,
    baseLNFT: 0,
    baseDoorSQFT: 0,

    wallSQFT: 0,
    wallLNFT: 0,
    wallDoorSQFT: 0,

    tallSQFT: 0,
    tallLNFT: 0,
    tallDoorSQFT: 0,

    handles: 0,
    doors: 0,
    drawers: 0,
  });

  const measureUnitLabels = MEASURE_UNITS_LABELS[sqftConfig.measureUnit];

  useEffect(() => {
    const calculateTotals = () => ({
      countertopArea: showManualCalculation ? manualCalculationsCountertopArea() : getCountertopArea().totalAreaToMeasureUnit,

      baseSQFT: getCabinetsDoorsSQFT([SHAPE_PART_ID.lower_cabinet_boxes]),
      baseLNFT: getCabinetsLNFT([SHAPE_PART_ID.lower_cabinet_boxes]),
      baseDoorSQFT: getCabinetsVolume([SHAPE_PART_ID.lower_cabinet_boxes]),

      vanitySQFT: getCabinetsDoorsSQFT([SHAPE_PART_ID.vanity_cabinet_boxes, SHAPE_PART_ID.vanitie_cabinet_boxes]),
      vanityLNFT: getCabinetsLNFT([SHAPE_PART_ID.vanity_cabinet_boxes, SHAPE_PART_ID.vanitie_cabinet_boxes]),
      vanityDoorSQFT: getCabinetsVolume([SHAPE_PART_ID.vanity_cabinet_boxes, SHAPE_PART_ID.vanitie_cabinet_boxes]),

      wallSQFT: getCabinetsDoorsSQFT([SHAPE_PART_ID.upper_cabinet_boxes]),
      wallLNFT: getCabinetsLNFT([SHAPE_PART_ID.upper_cabinet_boxes]),
      wallDoorSQFT: getCabinetsVolume([SHAPE_PART_ID.upper_cabinet_boxes]),

      tallSQFT: getCabinetsDoorsSQFT([SHAPE_PART_ID.tall_cabinet_boxes]),
      tallLNFT: getCabinetsLNFT([SHAPE_PART_ID.tall_cabinet_boxes]),
      tallDoorSQFT: getCabinetsVolume([SHAPE_PART_ID.tall_cabinet_boxes]),

      knobs: getQuantityFromFilters(CABINET_BOXES, 'Number_of_Knobs'),
      hinges: getQuantityFromFilters(CABINET_BOXES, 'Number_of_Hinges'),
      slideSets: getQuantityFromFilters(CABINET_BOXES, 'Numbe_of_Slide_Sets'),
      doors: getQuantityFromFilters(CABINET_BOXES, 'Number_of_Doors'),
      drawers: getQuantityFromFilters(CABINET_BOXES, 'Number_of_Drawers'),

      edgesArea: showManualCalculation ? manualCalculationsEdgesLength() : getEdgesArea(),
      backsplashArea: showManualCalculation ? manualCalculationsBacksplashArea() : getBacksplashTotalArea(),

      slabs: croppedSlabImages.length + sqftSlabManager.getSlabPlaceHolderShapes().length,
    });
    setTotals(calculateTotals());
  }, [updateCalculations, showManualCalculation, croppedSlabImages, countertopRows, backsplashRows, edgeRows]);

  const handleViewSummaryClick = () => {
    setSQFTActiveButton(SIDEBAR_BUTTONS_MENU.summary);
    setSQFTMenuOpened(menuOpened === SIDEBAR_BUTTONS_MENU.summary ? "" : SIDEBAR_BUTTONS_MENU.summary);
  };

  return (
    <div className="info-bar">
      <div className="info-bar-content swipable">
        {isShowSlabTool && (
          <div className="info-panel-wrapper">
            <button className="info-panel-title info-panel-button__hidden" onClick={handleViewSummaryClick}>
              <FormattedMessage id="sqft.footer.viewSummary" />
            </button>
          </div>
        )}
        <InfoPanel titleId="sqft.footer.countertopSize" value={totals.countertopArea} unit={measureUnitLabels.area} />
        <InfoPanel titleId="sqft.footer.baseSQFT"
                   value={totals.baseSQFT}
                   unit={measureUnitLabels.volume}
                   value2={totals.baseLNFT}
                   unit2={measureUnitLabels.length} />
        {/*<InfoPanel titleId="sqft.footer.baseLNFT" value={totals.baseLNFT} unit={measureUnitLabels.volume} />*/}
        {/*<InfoPanel titleId="sqft.footer.baseDoorSQFT" value={totals.baseDoorSQFT} unit={measureUnitLabels.volume} />*/}

        <InfoPanel titleId="sqft.footer.wallSQFT"
                   value={totals.wallSQFT}
                   unit={measureUnitLabels.volume}
                   value2={totals.wallLNFT}
                   unit2={measureUnitLabels.length}/>
        {/*<InfoPanel titleId="sqft.footer.wallLNFT" value={totals.wallLNFT} unit={measureUnitLabels.volume} />*/}
        {/*<InfoPanel titleId="sqft.footer.wallDoorSQFT" value={totals.wallDoorSQFT} unit={measureUnitLabels.volume} />*/}

        <InfoPanel titleId="sqft.footer.tallSQFT"
                   value={totals.tallSQFT}
                   unit={measureUnitLabels.volume}
                   value2={totals.tallLNFT}
                   unit2={measureUnitLabels.length}/>

        <InfoPanel titleId="sqft.footer.vanitySQFT"
                   value={totals.vanitySQFT}
                   unit={measureUnitLabels.volume}
                   value2={totals.vanityLNFT}
                   unit2={measureUnitLabels.length}/>

        {/*<InfoPanel titleId="sqft.footer.tallLNFT" value={totals.tallLNFT} unit={measureUnitLabels.volume} />*/}
        {/*<InfoPanel titleId="sqft.footer.tallDoorSQFT" value={totals.tallDoorSQFT} unit={measureUnitLabels.volume} />*/}

        <InfoPanel titleId="sqft.footer.doors" value={totals.doors} unit={measureUnitLabels.empty} />
        <InfoPanel titleId="sqft.footer.drawers" value={totals.drawers} unit={measureUnitLabels.empty} />
        <InfoPanel titleId="sqft.footer.knobs" value={totals.knobs} unit={measureUnitLabels.empty} />
        <InfoPanel titleId="sqft.footer.hinges" value={totals.hinges} unit={measureUnitLabels.empty} />
        <InfoPanel titleId="sqft.footer.slideSets" value={totals.slideSets} unit={measureUnitLabels.empty} />

        <InfoPanel titleId="sqft.footer.totalEdging" value={totals.edgesArea} unit={measureUnitLabels.area} />
        <InfoPanel titleId="sqft.footer.totalBacksplash" value={totals.backsplashArea} unit={measureUnitLabels.area} />

        {(fabricatorData.settings.showSlabMode || Config.isDevMode()) && !isMobile && totals.slabs > 0 && (
          <div className="info-panel-wrapper">
            <span className="info-panel-title">
              <FormattedMessage id="sqft.footer.totalSlab" />
            </span>
            <span className="info-panel-container">
              <span>#{totals.slabs}</span>
            </span>
            <SqftFooterSlabInfo />
          </div>
        )}
        <div className="info-panel-wrapper info-panel-colorset">
          <SqftFooterActiveShapeColorset />
        </div>
      </div>
      <div className={"info-bar-buttons" + (isModalFixOpen ? " hidden" : "")}>
        <button className="back-button buttons2__button buttons2__button--next hide">
          <FormattedMessage id="sqft.footer.buttonCalculateManually" />
        </button>
        <button className="back-button buttons2__button buttons2__button--prev hide">
          <FormattedMessage id="sqft.footer.buttonBackToDraw" />
        </button>
        <SqftFooterCancelButton />
        <SqftFooterAddToQuoteButton />
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  updateCalculations: store.sqftState.updateCalculations,
  croppedSlabImages: store.sqftSlabState.croppedSlabImages,
  countertopRows: store.sqftManualCalculationState.countertopRows,
  backsplashRows: store.sqftManualCalculationState.backsplashRows,
  edgeRows: store.sqftManualCalculationState.edgeRows,
  showManualCalculation: store.sqftManualCalculationState.showManualCalculation,
  fabricatorData: store.fabricatorState,
  isMobile: store.serverState.isMobile,
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
  isModalFixOpen: store.sqftModalFixState.isModalFixOpen,
});

const mapDispatchToProps = { setSQFTActiveButton, setSQFTMenuOpened };

export default connect(mapStateToProps, mapDispatchToProps)(SqftFooter);
